import { createAction } from 'redux-actions';

export const sendFeedback = createAction(
  'SEND_FEEDBACK',
  (payload) => payload,
  (payload, meta) => meta,
);
export const sendFeedbackSuccess = createAction('SEND_FEEDBACK_SUCCESS');
export const sendFeedbackFailure = createAction('SEND_FEEDBACK_FAILURE');
